import { UseCookiesQuery_cookies as Cookies } from '../../generated/types/UseCookiesQuery';

export const getSearchApiHeaders = (cookies: Cookies) => ({
  'client-country-code': cookies.clientCountryCode,
  'ab-tests': ['restrict-designers-to-us', 'sort-batch-final', 'no-trunkshow-on-new'].join(',')
});
